import { disallowedCharsRegex } from '@/utilities/constants';
/**
 * Check if the name has invalid characters.
 * @param name - input value
 */
export function hasInvalidSpecialCharacters(name) {
    return disallowedCharsRegex.test(name);
}
